import React from "react";

import { createMarkup, isFieldError } from "../../helpers";

const Textarea = ({
	label,
	note = "",
	reqd,
	name,
	value,
	update,
	errors,
	autocomplete = name,
	placeholder = "",
	readonly = false,
}) => {
	return (
		<div className={isFieldError(errors, name) ? "has-error" : ""}>
			<label htmlFor={name} className="control-label">
				<span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
				{reqd && <span className="reqd">*</span>}
			</label>
			<Textarea
				name={name}
				id={name}
				defaultValue={value || ""}
				onChange={(e) => update(name, e.target.value)}
				autoComplete={autocomplete}
				placeholder={placeholder}
				readOnly={readonly}
				className={
					isFieldError(errors, name)
						? "form-control error-border"
						: "form-control"
				}
			/>
			<span className={note ? "note" : "hidden"}>{note}</span>
		</div>
	);
};

export default Textarea;
